/**
 * Personal AI Trainer — first-time placement guide.
 * Stored under personal_ai_trainer_guide_shown in localStorage.
 */
import { useNavigate } from "react-router-dom";

export const GUIDE_FLAG = "personal_ai_trainer_guide_shown";

export default function PlacementGuide({ onDone }) {
  return (
    <div
      className="fixed inset-0 z-[80] bg-black/85 backdrop-blur-md flex items-center justify-center p-6"
      data-testid="pat-placement-guide"
    >
      <div className="max-w-md w-full bg-white rounded-[20px] p-6">
        <h2
          className="font-barlow-cond"
          style={{ fontSize: 26, fontWeight: 800, lineHeight: 1.05 }}
        >
          Place your phone where it can see your full body.
        </h2>
        <p
          className="mt-2"
          style={{
            fontSize: 13,
            fontWeight: 400,
            color: "#6B6760",
          }}
        >
          Good lighting helps accuracy.
        </p>

        <div className="mt-5 grid grid-cols-3 gap-2">
          <Illustration label="Squat / Lunge" body="standing" />
          <Illustration label="Push-up" body="floor" />
          <Illustration label="Plank" body="floor" />
        </div>

        <ul className="mt-4 space-y-1 text-[12.5px]" style={{ color: "#6B6760" }}>
          <li>· Squat or Lunge: phone at chest height, 1.5m away.</li>
          <li>· Push-up / Plank: phone at floor level, 1m away.</li>
        </ul>

        <button
          type="button"
          onClick={onDone}
          data-testid="pat-guide-got-it"
          className="mt-5 w-full h-12 rounded-pill"
          style={{ background: "#00D4FF", color: "#000", borderRadius: 100, fontWeight: 700 }}
        >
          Got it, start
        </button>
      </div>
    </div>
  );
}

function Illustration({ label, body }) {
  return (
    <div className="bg-canvas2 rounded-[14px] p-2 text-center">
      <svg viewBox="0 0 60 60" width="100%" height="60" aria-hidden="true">
        {/* Phone */}
        <rect
          x={body === "floor" ? 26 : 4}
          y={body === "floor" ? 48 : 24}
          width={body === "floor" ? 8 : 5}
          height={body === "floor" ? 4 : 9}
          rx={1}
          fill="#1A1A1A"
        />
        {/* Person body — minimal stick */}
        <g stroke="#00B0D5" strokeWidth="1.4" fill="none" strokeLinecap="round">
          {body === "standing" ? (
            <>
              <circle cx="40" cy="14" r="4" />
              <line x1="40" y1="18" x2="40" y2="36" />
              <line x1="40" y1="22" x2="34" y2="30" />
              <line x1="40" y1="22" x2="46" y2="30" />
              <line x1="40" y1="36" x2="35" y2="50" />
              <line x1="40" y1="36" x2="45" y2="50" />
            </>
          ) : (
            <>
              {/* Lying / push-up */}
              <circle cx="14" cy="46" r="3" />
              <line x1="17" y1="46" x2="48" y2="50" />
              <line x1="22" y1="47" x2="22" y2="54" />
              <line x1="40" y1="49" x2="40" y2="56" />
            </>
          )}
        </g>
      </svg>
      <div
        className="mt-1 text-[10.5px] font-semibold"
        style={{ color: "#1A1A1A" }}
      >
        {label}
      </div>
    </div>
  );
}
